module.exports = {
  MODULE: {
    ID: 'fa87516b-d6ca-40fc-9b17-e93b128f587b',
    TYPE: 'da36516b-d6ca-40fc-9b17-e93b128f587b',
    APPROVAL: 'd395238b-a2bf-42d4-941c-96a3c2aa1a28',
    OWNERS: '190802ad-c3fd-4cd5-ae59-4b592b4aa024',
    SOURCE: 'cb266790-66cc-473f-aa01-85c6c480aa33',
    CREATED_BY: '470e976a-850e-4ec9-ba2a-38fc49c06cf9',
    LAST_MODIFIED_BY: '5dd6edf1-1c2d-4bc3-b6eb-e821e421e02d',
    CREATED_AT: '69cb66d8-120c-48e3-8231-4bf139e0eaa5',
    LAST_MODIFIED_AT: '12fcd5ab-4508-41c9-94ab-06372ade518c',
    LAST_SENT_AT: '19db44e8-120c-48e3-8231-4bf139e0eaa5',
    FULL_NAME: 'full_name',
    ACCOUNTS_LIST: 'accounts_list',
    EVENT_LIST: 'event_list',
    SUBMITTING_ACCOUNT: '7465636f-ce0a-4b02-8d45-3351b90a855f',
    SUBMITTING_CONTACT: 'f1a468ae-a610-4897-a20e-2d1ebed45ff8',
    ACCOUNT_CONTACT: 'e2c468ae-b610-3897-a20e-2d1ebed45ff8',
    PRIMARY_CONTACT: 'd2c468ae-b610-3897-a20e-2d1ebed45ff8',
    ACCOUNT_LOGIN_USER: 'c2c468ae-b610-3897-a20e-2d1ebed45ff8',
    CONTACT_ROLE: 'e3d148ae-b610-3897-a20e-2d1ebed45ff8',
  },
  ACCOUNTS: {
    NAME: 'e8f3dac1-cce5-42be-bab1-0a88e8c03a72',
    WEBSITE: '0a93676a-6093-4078-a9f7-e2455dcbf982',
    ACCOUNT_SCORE: '15385556-e7e7-4dba-8619-bb26aae37087',
    ADDRESS_LINE_1: '6a0fa06c-8685-48f2-8347-e420f87086aa',
    ADDRESS_LINE_2: '4bf1f90b-5059-4e65-aec3-b8a997d2823b',
    ADDRESS_CITY: '2767c901-4a73-4909-81b4-ae853c499efd',
    ADDRESS_STATE: 'f8ee941b-307f-49f5-ac6a-07baaa92de2a',
    ADDRESS_ZIP: '68d917cb-5e1c-40db-bed1-b0719aab6bed',
    ADDRESS_COUNTRY: 'f396dbc4-7d93-4c24-8240-6e35a852c66e',
    PHONE: 'bae778db-289d-4890-a5b7-4d3e2150bd71',
    DESCRIPTION: 'e8b47247-d758-4a56-95d5-7d4acfc87522',
    PROFILE_APPROVAL: 'f9cb9844-f6d6-4bd4-bb08-2475bf1aada1',
    LOGO_URL: 'd6d12d9b-554b-4580-aa93-b83a98e9ad72',
    BANNER_URL: 'a3c80406-70f9-4231-b9a7-3a40895af843',
    LINKEDIN_URL: '16324ca6-834d-4585-90ea-971c6e309966',
    FACEBOOK_URL: '58046f29-8123-41e5-bd40-5cf7840b2a9b',
    TWITTER_URL: '20768177-caed-4e1e-8975-34ea217d1d68',
    USE_EMBARGOES: 'aefe51e0-fc7e-41df-bdbc-3542455545f5',
    TIER: '84a42c3b-e81e-4ec9-b5fd-2563f744e1ae',
  },
  CONTACTS: {
    ADDRESS_CITY: '4da66db6-a49a-469f-a5d5-d89c178fd731',
    ADDRESS_COUNTRY: 'a5f215fb-e308-48b6-a475-936cbad45ae9',
    ADDRESS_LINE_1: 'e2164897-3d8c-4907-9bfd-dfc83f0100e0',
    ADDRESS_LINE_2: '9063e65d-974c-47bb-9af4-b9a5ea9ce9e4',
    ADDRESS_STATE: '3c21f7b2-ac59-406c-83c3-29586673199d',
    ADDRESS_ZIP: '59d503dd-e650-48ea-864d-0b354e44e0e6',
    AVATAR_URL: 'b47a7f7f-06f6-4faa-b07b-79de812ccb4f',
    EMAIL: 'f80dea54-5ea0-413c-b82a-f8f39222ed9c',
    EVENT_DAYS: 'c1920e7f-bd30-4af2-81c9-5842cb4e9805',
    FIRST_NAME: '7608ee49-290c-4028-b4f9-32e231e65091',
    HOME_PHONE: 'c57f8f27-bdc0-4d93-8fa9-5d69ee37a102',
    LAST_NAME: 'aab68ab0-402c-434f-aecb-6d17fe582725',
    MOBILE_PHONE: 'eecf8c79-7942-4d25-b3ef-cd83b77fe691',
    SMS_OPT_IN: 'a496779c-fda4-4706-beab-c90bf95b1e89',
    TITLE: '0a3be0a1-82a2-49bf-a39c-43d81c90cd7d',
    ABOUT: '1f62ff1c-aa7b-4797-8f15-7704ca5cf599',
    WEBSITE: '97d9af93-dbd3-4c1c-8946-e3432039eaed',
    COMPANY_NAME: '6b52a52e-b494-4630-8270-56ec3b7bf862',
    LINKEDIN_URL: '07753976-51b2-4f67-8fe1-7b44694cb9b4',
    FACEBOOK_URL: '4f80a79e-5517-4766-a1d9-ba17eedeec59',
    TWITTER_URL: '3da7e373-2a84-47a7-b655-0079d8485ea5',
    CATERING_DIETARY_RESTRICTIONS: '7f51c27e-05bc-4151-b34d-d020f36f42a3',
    HONORIFIC: 'c349ff91-bc20-4e48-828f-33ff23acc06e',
    SALUTATION: '4cf135bb-8abe-4fbf-9359-b876a9860bd1',
    PRONOUNS: '774b502a-aee1-4440-9c36-a36a5536c402',
    GENDER: '33c9a154-ebdd-4361-bb81-f0b575cb2f30',
    PAST_COMPANIES: 'a13166eb-2c2a-4712-8ed4-db6f29938e2c',
    EDUCATIONAL_AFFILIATION: '04adec88-a448-4560-85c8-2d720208b72a',
    HIGH_LEVEL_OF_EDUCATION: 'c321a994-490a-4f3d-b07d-64840b2d1ce3',
    ETHNICITY: '0f74a649-dd09-47c0-bd31-4f61ed1d64c6',
    LANGUAGES: 'eb10af03-fd74-4d4e-9d66-36948572181e',
    SPEAKER_SCORE: 'fa20af03-fd74-4d4e-9d66-36948572181e',
    ORGANIZATION_CONTACT: 'eae5ce95-839c-436c-8f88-590fecbb9bd3',
    SPEAKER_FEE: '498deb1f-4d98-4315-ac85-961d656c7d27',
    AVAILABILITY: 'b0ea6e9c-efae-4ce7-b14a-22c3afcccede',
    PREFERRED_SESSION_FORMAT: '168c0cc2-a26d-4b3d-9bfb-ee17ee89d162',
    ANNUAL_REVENUE: '232c0cc2-a26d-4b3d-9bfb-ee17ee89d162',
    HEADCOUNT: '9ac68c7d-2d6e-461a-b23e-dfbca219890f',
    YEARS_IN_OPERATION: '536ab8c9-0fa8-4ebd-ab56-f07dd8bae2cb',
    ORGANIZATION_STRUCTURE: '589cba8b-001a-4e42-8247-e165b1de0d9a',
    INDUSTRY: '25603d8f-f5f9-4c46-b33a-fa124e5414f7',
    GLOBAL_REGION: 'dc295630-e42f-40f6-bf0c-deb44bfa2dfb',
    AUDIENCE_TYPE: '25a5eaf4-9a6e-4fa9-903c-21e6e0b3a073',
    TARGET_AGE_RANGE: '94bb95f2-7775-4895-9497-1884edca1bdf',
    TOPIC_EXPERTISE: 'bfe9a68d-e774-4cbe-a7cc-e6fe7a532993',
    BRAND: '9a4b18a9-af02-497a-8762-7798002a93f1',
  },
  SCHEDULES: {
    NAME: '5e52bb94-e24e-4109-9a49-1efbc11d5697',
    STARTS_AT: '1251d7b5-07d7-4d3b-9058-3188ff6b445f',
    ENDS_AT: '2d35d161-b6f4-45e8-915a-d421b3d33c68',
    ASSIGNED_TO_USER: '3204ec45-763f-4ba7-944e-ffd57e51615d',
    ASSIGNED_TO: 'b38fedb5-babd-4fca-9df5-dc8bf2dbf895',
    LOCATION: '32a4e923-893d-4c26-bd58-492e6ce9512d',
    SCHEDULE: 'e995e32c-d569-4181-806e-74be717ff23e',
    COMPLETE: 'e78a7596-2ea9-489e-830a-656e32c96a57',
    NOTES: '5cda3a4b-6929-4144-93cb-d77d56a7e244',
  },
  EVALUATION_PLANS: {
    EXTERNAL_COMMENTS: '5e8a5d8e-958a-455c-8acf-51f7d3ee5633',
    INTERNAL_COMMENTS: '94346cc5-379c-463a-b1a2-600a8c894e16',
  },
  APPLICATIONS: {
    APPLICANT_ACCOUNT: '6e52bb94-e24e-4109-9a49-1efbc11d5697',
    APPLICANT_CONTACT: '2251d7b5-07d7-4d3b-9058-3188ff6b445f',
  },
  LOCATIONS: {
    NAME: '55b7fb9e-509a-4b83-b0f2-0d36146f62f7',
    DESCRIPTION: 'bc9ce007-5b40-476a-9c79-2ab3ff3616b6',
  },
  LOCATION_AREAS: {
    LOCATION: '4859d913-0fdc-49e1-8f23-fc7bcddb3cfa',
    NAME: '3d97f429-ff66-4e13-96ee-03531827b1ed',
    DESCRIPTION: '10053cae-edff-4523-aa68-712b97ce30db',
  },
  FILES: {
    MIMETYPE: '250b390a-8307-4130-bb12-3df6e8ea0af3',
    FILENAME: '8fc10190-5c45-42de-8c9b-6a9c2e003b36',
    DESCRIPTION: 'd87fd0b2-a84e-4f70-92be-864b457115dc',
    TITLE: 'ea87516b-d6ca-40fc-9b17-e93b128f587b',
    URL: 'f26fe10c-993d-485f-aa85-110dd748a66a',
    SIZE: 'fb902676-4395-4e99-9548-dcf7413456af',
  },
  DOCUMENT_REQUEST_TYPES: {
    NAME: '9276c086-c54d-4014-ae5b-d9e8344451d5',
    ASSIGNMENT_SCOPE: '74aa2afe-d01b-4f29-8d38-e0b97127839c',
    SAMPLE_DOCUMENTS: '5b3a5a22-c2f6-4540-8321-941edb5dd776',
    DUE_DATE: '0d208b09-8789-4675-8bfa-ab1209050985',
    CRITERIA: 'a273445b-fc82-49ca-9959-e0898d4c7560',
    ENABLE_REMINDERS: 'e3fc13c0-2b3c-4842-8cf4-7b282cb33cdb',
  },
  DOCUMENT_REQUESTS: {
    REQUEST_NAME: '622bc45b-1785-458f-b0cb-de40c9cde5f4',
    REQUEST_REVISION_STATUS: '511bc45b-1785-458f-b0cb-de40c9cde5f5',
    REQUEST_TYPE_NAME: '681bc45b-1785-458f-b0cb-de40c9cde5f5',
    RECIPIENT_NAME: 'a006b32a-f525-4c6a-bc77-5a80fac2d5ed',
  },
  DOCUMENT_REQUEST_REVISIONS: {
    REVISION_STATUS: 'd673b653-dd0b-4c91-9c09-1ccd05ac4dc2',
    FILES: '0c1c0f53-b569-44c8-948e-a7ef5484b8cb',
  },
  FORMSV3: {
    MODULE: 'f27e89ba-4f64-4446-81a6-18c03d9150be',
    NAME: 'b90299dd-f26c-40d5-9279-f2ab7682c8bd',
    CLOSE_DATE: '45761507-40c3-41ff-bcec-68b23b482a2c',
    RESPONSES_REQUIRE_APPROVAL: '9445d63a-6dd8-429b-8cec-d9a354a194eb',
    SHOW_SHARE_LINK: 'aea05399-b687-4959-a551-c670badb11dd',
    LOCK_ON_SUBMISSION: 'c21d8693-d799-458e-87d0-6a3cbaaa5e4a',
    IS_LOCKED: '54735af8-7045-41d8-b22b-f254daa36ee6',
  },
  CATALOG_CATEGORIES: {
    NAME: '94ea651b-f921-4054-9a0f-a364990a3efa',
  },
  CATALOG_ITEMS: {
    TRACK_BY: 'a9b914f9-aaa9-49a6-89d9-0441c6772e63',
    IMAGE: 'b13a3dd4-779d-4b5b-b3f2-fabdd2c47145',
    CATEGORY: '7deca04e-8948-4388-acb1-440f58b8a5f7',
    ITEM_NAME: '25fbaafc-d2f0-487b-9ed5-555ea37fb4d1',
    UNIT_OF_MEASURE: '7c9e25af-e169-4771-99d9-d82fda49ad7a',
  },
  HEALTH_PASS: {
    SYMPTOMS: '8c539d3c-eeb5-4b2a-a7e6-327fd45c4f4c',
    PROXIMITY: '6854115b-a359-432e-978e-e2d7168b1ba9',
    CURRENTLY_ILL: '81b4fcee-acde-4f2e-aec6-eaf4cc0cc86c',
  },
  SESSIONS: {
    TITLE: '3eebf724-32e0-41ea-925e-3b7305ee996c',
    CLIENT_ID: '2fabf724-32e0-41ea-925e-3b7305ee996c',
    DESCRIPTION: '3ca47870-4000-4d23-8f9d-8074b7d8d7a5',
    NOTES: '4493c9cf-7a89-4852-8244-d83b09dcae95',
    FORMAT: 'ac5f0014-f922-4be5-b9a8-1a59d724b9e0',
    TAGS: '6e6c5be5-6e03-4551-843b-aa2c13ad63d5',
    LEVEL: '2397dc8d-1767-4494-829a-ae2ddb8e4b89',
    LANGUAGE: '30af20e5-049a-49f0-9ffc-0ec23782c2bc',
    TRACK: '01c2f413-997c-4c1a-affb-c7fb8fbfe16a',
    STATUS: '45a127e3-7774-4900-b307-ed5fcfa8b631',
    OWNER: '1142aca6-2bf1-4720-b8ac-9408569fb060',
    LOCATION: 'c489644c-70e5-40c9-a0d0-6cd03e34dc8e',
    SPEAKERS: 'd353ff20-effd-44dc-924b-3280c47e9918',
    STARTS_AT: '721acb70-c823-48c2-ae38-5db988f2f20b',
    ENDS_AT: '077db8af-33c0-40d2-a7e0-ccaff75968d1',
    CEU_CREDITS: 'fbd6bf39-afda-438c-b0be-9444fc61f238',
    FRIENDLY_ID: '6e94389f-b999-461f-9fc9-e68fcad1a23e',
  },
};
